import React from 'react';
import { faWindowClose } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const ModalWindowCloseIcon = () => (
  <Icon tooltip="Close Modal Window" iconObj={faWindowClose} />
);

export default ModalWindowCloseIcon;